import React from 'react';
import { Link } from 'react-router-dom';
import { Briefcase, BookOpen, ChevronRight } from 'lucide-react';
import { useJobs } from '../../hooks/admin/useJobs';
import { useCourseList } from '../../hooks/courses/useCourseList';
import { LoadingSpinner } from '../common/LoadingSpinner';

export function RecentUpdates() {
  const { jobs, isLoading: jobsLoading } = useJobs();
  const { courses, isLoading: coursesLoading } = useCourseList();

  if (jobsLoading || coursesLoading) {
    return (
      <div className="bg-[#2A1114] rounded-[8px] p-6 shadow-lg mb-6">
        <div className="flex justify-center">
          <LoadingSpinner />
        </div>
      </div>
    );
  }

  const recentJobs = jobs.slice(0, 3);
  const recentCourses = courses.slice(0, 3);

  return (
    <div className="space-y-6 mb-6">
      {/* Latest Jobs */}
      <div className="bg-[#2A1114] rounded-[8px] p-6 shadow-lg">
        <div className="flex items-center justify-between mb-6">
          <div className="flex items-center space-x-2">
            <Briefcase className="h-5 w-5 text-white" />
            <h2 className="text-lg font-semibold text-white">Latest Jobs</h2>
          </div>
          <Link 
            to="/jobs"
            className="text-white hover:opacity-80 text-sm flex items-center"
          >
            View All
            <ChevronRight className="h-4 w-4 ml-1" />
          </Link>
        </div>

        <div className="space-y-4">
          {recentJobs.map((job) => (
            <Link
              key={job.id}
              to={`/jobs/${job.id}`}
              className="block group"
            >
              <div className="flex items-center space-x-4">
                <img
                  src={job.logo}
                  alt={job.company}
                  className="w-12 h-12 rounded-lg object-cover flex-shrink-0"
                />
                <div>
                  <h3 className="text-white font-medium group-hover:opacity-80 transition-opacity">
                    {job.title}
                  </h3>
                  <p className="text-gray-300 text-sm">{job.location}</p>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>

      {/* Latest Courses */}
      <div className="bg-[#2A1114] rounded-[8px] p-6 shadow-lg">
        <div className="flex items-center justify-between mb-6">
          <div className="flex items-center space-x-2">
            <BookOpen className="h-5 w-5 text-white" />
            <h2 className="text-lg font-semibold text-white">Latest Courses</h2>
          </div>
          <Link 
            to="/courses/marketplace"
            className="text-white hover:opacity-80 text-sm flex items-center"
          >
            View All
            <ChevronRight className="h-4 w-4 ml-1" />
          </Link>
        </div>

        <div className="space-y-4">
          {recentCourses.map((course) => (
            <Link
              key={course.id}
              to={`/courses/${course.id}`}
              className="block group"
            >
              <div className="flex items-center space-x-4">
                <img
                  src={course.image_url}
                  alt={course.title}
                  className="w-12 h-12 rounded-lg object-cover flex-shrink-0"
                />
                <div>
                  <h3 className="text-white font-medium group-hover:opacity-80 transition-opacity">
                    {course.title}
                  </h3>
                  <p className="text-gray-300 text-sm">{course.provider}</p>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}